import React from 'react';
import InitialAssessmentEdit from '../InitialAssessment/InitialAssessmentEdit';

const NurseAssessmentEdit = () => {
    return (
        <InitialAssessmentEdit isNurse = {true}/>
    );
};
export default NurseAssessmentEdit;
